import { Box, IconButton, Typography } from '@material-ui/core'
import { ThemeModal } from 'components/core/ThemeModal/ThemeModal'
import { PropsWithChildren } from 'react'
import { AnimatedAvatar } from './styled'
import { ReactComponent as CompanyIcon } from 'icons/company.svg'
import { ReactComponent as EventIcon } from 'icons/event.svg'
import { ReactComponent as HomeIcon } from 'icons/home.svg'
import { ReactComponent as MoonIcon } from 'icons/moon.svg'
import { ReactComponent as NetworkIcon } from 'icons/people.svg'
import { ReactComponent as SunIcon } from 'icons/sun.svg'
import styled from 'styled-components'
import { ExitToAppOutlined, Feedback, LockOutlined, PersonAdd, VpnKey } from '@material-ui/icons'
import { Logo } from '../logo'
import { NotificationDrawer } from 'components/page/notifications/NotificationDrawer'
import { FeedbackModal } from 'pages/auth/components/feedback/FeedbackModal'
import { InviteFriendsByEmailModal } from 'pages/auth/components/invite-friends/InviteFriendsByEmailModal'
import { ChangePasswordModal } from 'pages/settings/components/ChangePasswordModal'
import { Notifications } from '../notifications'
import { SearchBar } from 'components/core/search'
import { NavbarDropdownMenu } from 'components/core/actions-menu/NavbarDropdownMenu'
import { ProfileStatus } from '../profile-status/ProfileStatus'
import { StyledUserButton } from './MainContainer'
import { UserFeedback, UserRoles } from 'common/types'
import { useMainWrapperNavBar } from './useMainWrapperNavBar'
import { MainWrapperNavBarLink } from './MainWrapperNavBarLink'
import { MainWrapperDrawerItem } from './MainWrapperDrawerItem'
import { SideNavList } from '../side-nav/SideNavList'

export const StyledIconButton = styled(IconButton)`
  && {
    margin: 0 0 0 -0.5em;
    height: 20px;
    align-self: center;
  }
`
export const StyledAdminKeyButton = styled(VpnKey)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledFeedbackButton = styled(Feedback)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.primary};
  }
`
export const StyledExitButton = styled(ExitToAppOutlined)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledLockButton = styled(LockOutlined)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
const StyledMoonIcon = styled(MoonIcon)`
  && {
    height: 17px;
    width: 17px;
  }
`
const StyledSunIcon = styled(SunIcon)`
  && {
    height: 17px;
    width: 17px;
  }
`
const StyledCompanyButton = styled(CompanyIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    stroke: ${props => props.theme.colors.accent1};
    width: 1em;
    height: 1em;
  }
`
export const StyledPersonButton = styled(PersonAdd)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledHomeIcon = styled(HomeIcon)`
  cursor: pointer;
`
export const StyledNetworkIcon = styled(NetworkIcon)`
  cursor: pointer;
`
export const StyledEventIcon = styled(EventIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
  }
`

export interface IMainWrapperNavBarProps {
  shrinkLogo: any
  stickTopBar: any
  hideActions: any
  showAvatar: any
  hideLinks: any
  isPostingContent: any
  nopadding?: boolean
  showSearch: any
  setSearchTab: any
  setPageNum: any
  setResults: any
  inviteUsersByEmail: any
}

export const MainWrapperNavBar = (props: PropsWithChildren<IMainWrapperNavBarProps>) => {
  const {
    shrinkLogo,
    stickTopBar,
    hideActions,
    showAvatar,
    isPostingContent,
    showSearch,
    setSearchTab,
    setPageNum,
    setResults,
    inviteUsersByEmail
  } = props

  const {
    showInviteFriends,
    setShowInviteFriends,
    showFeedback,
    setShowFeedback,
    overlayTabIndex,
    setOverlayTabIndex,
    onLogout,
    isAuthenticated,
    backendUser,
    backendPartner,
    isDevice,
    isTablet,
    notify,
    openSideBar,
    setOpenSideBar,
    history,
    pathname,
    mode,
    theme,
    unreadNotifications,
    drawer,
    setDrawer,
    totalNotifications,
    setPage: setNotificationPage,
    page: notificationPage,
    updateNotification,
    setNotifications,
    setTotalNotifications,
    clearNotifications,
    showNotificationAlert,
    handleAlertClick,
    handleStoringLatestNotification,
    handleModeChange,
    loadingPreference,
    getProfilePercentage,
    logEventAnalytics,
    vDetails,
    setError,
    password,
    setPassword,
    passwordValid,
    setPasswordValid,
    onResetPasswordWithUser,
    passwordChange,
    setPasswordChange,
    showChangePassword,
    setShowChangePassword,
    currentPassword,
    setCurrentPassword,
    handleErrorMessage,
    confirmPassword,
    setConfirmPassword,
    confirmPasswordValid,
    setConfirmPasswordValid,
    onCurrentPasswordChange,
    onPasswordChange,
    onConfirmPasswordChange,
    createFeedback,
    handleAvatarClickTracker,
    navbarPadding,
    forceUpdate,
    toggleDrawer
  } = useMainWrapperNavBar(props)

  return (
    <>
      <Box
        bgcolor={theme.colors.supplementary}
        p={navbarPadding()}
        display="flex"
        justifyContent="center"
        top="0"
        zIndex="3"
        position={stickTopBar ? 'fixed' : 'unset'}
        boxShadow={theme.colors.shadowXSmall}
        width="100%"
        height="70px"
      >
        <Box
          maxWidth="80em"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          margin="auto"
          width="100%"
          height="100%"
        >
          <ThemeModal loading={isPostingContent ? isPostingContent : loadingPreference} />
          {isDevice && (
            <Box display="flex" flexDirection="row" width="100%" alignItems="center" justifyContent="space-between">
              <Box p={0} width="70%">
                <IconButton color="secondary" onClick={() => setOpenSideBar(true)}>
                  {showAvatar && (
                    <AnimatedAvatar
                      src={backendUser?.image}
                      alt="member with a profile"
                      style={{ width: '2em', height: '2em' }}
                    />
                  )}
                </IconButton>
              </Box>
              <Box p={0} display="flex" flexDirection="row" width="100%" alignItems="center">
                <Logo pathname={pathname} bright size={shrinkLogo ? 'x-small' : 'small'} />
              </Box>
              <Box
                flexShrink={0}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color={theme.colors.accent1}
                onClick={() => history.push('/events')}
              >
                <StyledEventIcon />
                <Typography variant="caption">
                  <Box fontWeight="bold">Events</Box>
                </Typography>
              </Box>
              <Box p={2} flexShrink={0}>
                <Notifications
                  theme={theme}
                  setDrawer={setDrawer}
                  setTab={setOverlayTabIndex}
                  showAlert={showNotificationAlert}
                  handleClick={handleAlertClick}
                />
              </Box>
            </Box>
          )}
          {!isDevice && (
            <Box display="flex" alignItems="center" position="relative">
              <Logo pathname={pathname} bright size={shrinkLogo ? 'x-small' : 'small'} />
              {showSearch && (
                <SearchBar
                  setSearchTab={setSearchTab}
                  setPageNum={setPageNum}
                  setResults={setResults}
                  backendUser={backendUser}
                  isDevice={isDevice}
                  isTablet={isTablet}
                />
              )}
            </Box>
          )}
          {!hideActions && !isDevice && (
            <Box width="100%">
              <Box display="flex" justifyContent="flex-end" gridGap="4em">
                <MainWrapperNavBarLink
                  to="/feed"
                  linkIcon={<StyledHomeIcon fill={theme.colors.accent} />}
                  onClickHandler={() => {
                    const partnerLog = {}
                    const userLog = {}
                    userLog['User ID'] = backendUser?.id
                    if (backendUser?.partnerId) {
                      partnerLog['Partner ID'] = backendPartner?.id
                      partnerLog['Company Name'] = backendPartner?.name
                      partnerLog['Account Type'] = 'Partner'
                    } else {
                      userLog['Account Type'] = backendUser?.role
                    }
                    logEventAnalytics(
                      backendUser?.partnerId ? 'Partner' : 'Member',
                      'Posts viewed',
                      'mixpanel',
                      'Posts viewed',
                      { ...partnerLog, ...userLog },
                      backendUser?.id
                    )
                    forceUpdate()
                  }}
                >
                  Tea Spot
                </MainWrapperNavBarLink>
                <MainWrapperNavBarLink
                  linkIcon={<StyledNetworkIcon fill={theme.colors.accent} />}
                  to="/connections"
                  onClickHandler={() => {
                    logEventAnalytics(
                      backendUser?.partnerId ? 'Partner' : backendUser?.role,
                      'View Connections',
                      'both',
                      'View Connections',
                      {
                        'Connection viewer email': backendUser?.username,
                        'Connection viewer ID': backendUser?.id,
                        'Account type': backendUser?.partnerId ? 'Partner' : backendUser?.role
                      },
                      backendUser?.id,
                      {
                        $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
                        $email: backendUser?.username
                      }
                    )
                  }}
                  mr="3em"
                >
                  My Tribe
                </MainWrapperNavBarLink>
              </Box>
            </Box>
          )}
          {!hideActions && !isDevice && (
            <>
              <Box display="flex" alignItems="center">
                {isAuthenticated && (
                  <>
                    <Box mr="4em">
                      <Notifications
                        theme={theme}
                        setDrawer={setDrawer}
                        setTab={setOverlayTabIndex}
                        showAlert={showNotificationAlert}
                        handleClick={handleAlertClick}
                      />
                    </Box>
                    <NavbarDropdownMenu
                      title=""
                      icon={
                        <ProfileStatus
                          percentage={getProfilePercentage(backendUser)}
                          avatar={backendUser?.image}
                          name={backendUser?.firstName}
                          onClick={() => handleAvatarClickTracker('Profile menu')}
                        />
                      }
                    >
                      <MainWrapperDrawerItem
                        to={'/profile'}
                        linkIcon={<StyledUserButton />}
                        onClick={() => handleAvatarClickTracker('My Page from Profile menu')}
                      >
                        My Page
                      </MainWrapperDrawerItem>

                      {backendUser?.partnerId && (
                        <MainWrapperDrawerItem
                          to={`/company/${backendUser?.partnerId}`}
                          linkIcon={<StyledCompanyButton />}
                          onClick={() => handleAvatarClickTracker('Company Page from Profile menu')}
                        >
                          My Page
                        </MainWrapperDrawerItem>
                      )}

                      {backendUser?.authType === 'creds' && (
                        <MainWrapperDrawerItem
                          linkIcon={<StyledLockButton />}
                          onClick={() => {
                            setShowChangePassword(true)
                            handleAvatarClickTracker('Change Password from Profile menu')
                          }}
                        >
                          Change Password
                        </MainWrapperDrawerItem>
                      )}

                      <MainWrapperDrawerItem
                        linkIcon={<StyledPersonButton />}
                        onClick={() => setShowInviteFriends(true)}
                      >
                        Invite Peeps
                      </MainWrapperDrawerItem>
                      <MainWrapperDrawerItem
                        linkIcon={<StyledFeedbackButton />}
                        onClick={() => {
                          setShowFeedback(true)
                          handleAvatarClickTracker('Feedback clicks from Profile menu')
                        }}
                      >
                        Feedback
                      </MainWrapperDrawerItem>
                      <MainWrapperDrawerItem
                        linkIcon={mode === 'dark' ? <StyledMoonIcon /> : <StyledSunIcon />}
                        onClick={() => {
                          handleModeChange()
                          handleAvatarClickTracker('Mode from Profile menu', {
                            'Mode Category': mode === 'dark' ? 'Dark' : 'Light'
                          })
                        }}
                      >
                        Mode
                      </MainWrapperDrawerItem>

                      {backendUser?.role === UserRoles.Admin && (
                        <MainWrapperDrawerItem
                          linkIcon={<StyledAdminKeyButton />}
                          onClick={() => {
                            history.push('/admin/home')
                            const partnerLog = {}
                            const userLog = {}
                            userLog['User ID'] = backendUser?.id
                            if (backendUser?.partnerId) {
                              partnerLog['Partner ID'] = backendPartner?.id
                              partnerLog['Company Name'] = backendPartner?.name
                              partnerLog['Account Type'] = 'Partner'
                            } else {
                              userLog['Account Type'] = backendUser?.role
                            }
                            logEventAnalytics(
                              backendUser?.partnerId ? 'Partner' : backendUser?.role,
                              'Admin Page',
                              'both',
                              'Admin Page Clicked',
                              { ...partnerLog, ...userLog },
                              backendUser?.id
                            )
                          }}
                        >
                          Administrator
                        </MainWrapperDrawerItem>
                      )}
                      <Box bgcolor={theme.colors.supplementary} width="100%" height="0.1em"></Box>

                      <MainWrapperDrawerItem
                        linkIcon={<StyledExitButton />}
                        onClick={() => onLogout()}
                      >
                        Logout
                      </MainWrapperDrawerItem>
                    </NavbarDropdownMenu>
                  </>
                )}
              </Box>
            </>
          )}
        </Box>
      </Box>
      <SideNavList
        getProfilePercentage={getProfilePercentage(backendUser)}
        toggleDrawer={toggleDrawer}
        inviteUsersByEmail={inviteUsersByEmail}
      />

      <NotificationDrawer
        user={backendUser}
        drawer={drawer}
        setDrawer={setDrawer}
        setNotifications={setNotifications}
        setTotalNotifications={setTotalNotifications}
        theme={theme}
        notifications={unreadNotifications}
        totalNotifications={totalNotifications}
        isDevice={isDevice}
        isTablet={isTablet}
        updateNotification={updateNotification}
        tabIndex={overlayTabIndex}
        setTabIndex={setOverlayTabIndex}
        backendUser={backendUser}
        clearNotifications={clearNotifications}
        setNotificationPage={setNotificationPage}
        notificationPage={notificationPage}
        handleStoringLatestNotification={handleStoringLatestNotification}
      />

      <ChangePasswordModal
        show={showChangePassword}
        setShowChangePassword={setShowChangePassword}
        onClose={() => {
          setCurrentPassword('')
          setPassword('')
          setConfirmPassword('')
          setError('')
          setShowChangePassword(false)
        }}
        setError={setError}
        vDetails={vDetails}
        password={password}
        setPasswordValid={setPasswordValid}
        setPassword={setPassword}
        passwordValid={passwordValid}
        onSubmit={() => onResetPasswordWithUser(backendUser?.id)}
        passwordChange={passwordChange}
        setPasswordChange={setPasswordChange}
        currentPassword={currentPassword}
        setCurrentPassword={setCurrentPassword}
        handleErrorMessage={handleErrorMessage}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        confirmPasswordValid={confirmPasswordValid}
        setConfirmPasswordValid={setConfirmPasswordValid}
        onCurrentPasswordChange={onCurrentPasswordChange}
        onPasswordChange={onPasswordChange}
        onConfirmPasswordChange={onConfirmPasswordChange}
      />
      <InviteFriendsByEmailModal
        inviteUsersByEmail={inviteUsersByEmail}
        notify={notify}
        backendUser={backendUser}
        show={showInviteFriends}
        onClose={() => setShowInviteFriends(false)}
        partnerId={backendPartner?.id}
      />
      <FeedbackModal
        show={showFeedback}
        onClose={() => setShowFeedback(false)}
        onAdd={async (data: UserFeedback) => {
          const feedback = await createFeedback(data)
          handleAvatarClickTracker('Feedback submission', {
            'Feedback Category': feedback?.category,
            'Attached File': feedback?.attachment
          })
        }}
      />
    </>
  )
}
